import { Dialog } from '@headlessui/react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CheckoutNoteDialogProps {
  open: boolean;
  onClose: () => void;
  note: string;
}

export function CheckoutNoteDialog({ open, onClose, note }: CheckoutNoteDialogProps) {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      className="relative z-50"
    >
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-md w-full rounded-lg bg-white dark:bg-gray-800 max-h-[90vh] flex flex-col">
          {/* Header */}
          <div className="p-6 border-b dark:border-gray-700">
            <div className="flex items-center justify-between">
              <Dialog.Title className="text-lg font-medium text-gray-900 dark:text-white">
                Important Notice
              </Dialog.Title>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>

          {/* Scrollable Content */}
          <div className="p-6 overflow-y-auto flex-1">
            <div className="prose prose-sm dark:prose-invert">
              <div 
                className="text-gray-600 dark:text-gray-300"
                dangerouslySetInnerHTML={{ __html: note.replace(/\n/g, '<br>') }}
              />
            </div>
          </div>

          {/* Footer */}
          <div className="p-6 border-t dark:border-gray-700">
            <Button
              onClick={onClose}
              className="w-full"
            >
              I Understand
            </Button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}